export default "__VITE_ASSET__B5iF$2lw__"